import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Papa from 'papaparse';

const Cart = ({ cart, setCart }) => {
  // Detect dark mode from App.js class
  const isDarkMode = document.body.classList.contains('dark-mode') || document.querySelector('.App.dark-mode');
  const [shippingCost, setShippingCost] = useState(0);
  const [firstName, setFirstName] = useState('');
  const [surname, setSurname] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [postcode, setPostcode] = useState('');
  const [country, setCountry] = useState('');
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch('/ProductData.csv')
      .then(response => response.text())
      .then(data => {
        const parsedData = Papa.parse(data, { header: true, dynamicTyping: true }).data;
        parsedData.forEach(product => {
          // Ensure images field is defined and not empty before splitting
          if (product.images) {
            product.images = product.images.split('|').map(image => image.trim());
          } else {
            product.images = []; // Set to empty array if images field is undefined or empty
          }
        });
        setProducts(parsedData);
      });
  }, []);

  // cart and setCart are now from props, no need to load from localStorage

  const removeFromCart = (itemId, quantityToRemove) => {
    const updatedCart = cart.map(item => {
      if (item.id === itemId) {
        return {
          ...item,
          quantity: item.quantity - quantityToRemove
        };
      }
      return item;
    }).filter(item => item.quantity > 0);
    setCart(updatedCart);
  };

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };

  const handleSurnameChange = (event) => {
    setSurname(event.target.value);
  };

  const handleStreetChange = (event) => {
    setStreet(event.target.value);
  };

  const handleCityChange = (event) => {
    setCity(event.target.value);
  };

  const handlePostcodeChange = (event) => {
    setPostcode(event.target.value);
    calculateShippingCost(event.target.value, country);
  };

  const handleCountryChange = (event) => {
    setCountry(event.target.value);
    calculateShippingCost(postcode, event.target.value);
  };

  const calculateShippingCost = (postcode, country) => {
    let cost = 0;
    if (postcode && country) {
      if (country.toLowerCase() === 'usa') {
        cost = 10; // $10 flat rate for USA
      } else {
        cost = 20; // $20 flat rate for other countries
      }
    }
    setShippingCost(cost);
  };

  const getItemDetails = (itemId) => {
    return products.find(item => item.id === itemId);
  };

  const getTotalValue = () => {
    const itemsTotal = cart.reduce((total, item) => {
      const product = getItemDetails(item.id);
      return total + (product ? product.price * item.quantity : 0);
    }, 0);
    return itemsTotal + shippingCost;
  };

  return (
    <div>
      <div className='main' style={{ display: 'flex', gap: '32px', alignItems: 'flex-start', color: isDarkMode ? '#fff' : '#222' }}>
        {/* Info/Form Section (Left) */}
        <div style={{ flex: '0 0 340px', background: isDarkMode ? '#222' : '#fafafa', borderRadius: '10px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <h2>Shipping Info</h2>
          <form>
            <div style={{ marginBottom: '12px' }}>
              <label>First Name<br /><input type="text" value={firstName} onChange={handleFirstNameChange} style={{ background: isDarkMode ? '#333' : '#fff', color: isDarkMode ? '#fff' : '#222' }} /></label>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label>Surname<br /><input type="text" value={surname} onChange={handleSurnameChange} style={{ background: isDarkMode ? '#333' : '#fff', color: isDarkMode ? '#fff' : '#222' }} /></label>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label>Street<br /><input type="text" value={street} onChange={handleStreetChange} style={{ background: isDarkMode ? '#333' : '#fff', color: isDarkMode ? '#fff' : '#222' }} /></label>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label>City<br /><input type="text" value={city} onChange={handleCityChange} style={{ background: isDarkMode ? '#333' : '#fff', color: isDarkMode ? '#fff' : '#222' }} /></label>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label>Postcode<br /><input type="text" value={postcode} onChange={handlePostcodeChange} style={{ background: isDarkMode ? '#333' : '#fff', color: isDarkMode ? '#fff' : '#222' }} /></label>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <label>Country<br /><input type="text" value={country} onChange={handleCountryChange} style={{ background: isDarkMode ? '#333' : '#fff', color: isDarkMode ? '#fff' : '#222' }} /></label>
            </div>
            <div style={{ marginBottom: '12px' }}>
              <strong>Shipping Cost: ${shippingCost.toFixed(2)}</strong>
            </div>
          </form>
        </div>
        {/* Cart Items Section (Right) */}
        <div style={{ flex: 1, background: isDarkMode ? '#222' : '#fff', borderRadius: '10px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>Your Cart</h2>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {cart.map(cartItem => {
              const product = getItemDetails(cartItem.id);
              if (!product || typeof product.price !== 'number') {
                return (
                  <li key={cartItem.id} style={{ color: isDarkMode ? '#ffb3b3' : 'red', marginBottom: '18px', padding: '12px', borderBottom: '1px solid #eee' }}>
                    <span>Unknown Product</span>
                  </li>
                );
              }
              return (
                <li key={cartItem.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px', padding: '12px', borderBottom: '1px solid #eee' }}>
                  <span style={{ fontWeight: 500 }}>{product.name}</span>
                  <span>${product.price.toFixed(2)}</span>
                  <span>Qty: {cartItem.quantity}</span>
                  <button style={{ marginLeft: '16px' }} onClick={() => removeFromCart(cartItem.id, cartItem.quantity)}>Remove</button>
                </li>
              );
            })}
          </ul>
          {postcode && country && (
            <p>Shipping Cost: ${shippingCost.toFixed(2)}</p>
          )}
          {cart.length > 0 && (
            <div>
              <h3>Total Value: ${getTotalValue().toFixed(2)}</h3>
            </div>
          )}
          <Link to="/checkout">
            <button>Checkout</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cart;
